/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Editor_Export_Pdf_FailedInputs */



/**
* | output |
* | --- |
* | "Failed to export PDF" |
*
* @param {Editor_Export_Pdf_FailedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const editor_export_pdf_failed = /** @type {((inputs?: Editor_Export_Pdf_FailedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Editor_Export_Pdf_FailedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Fehler beim Exportieren als PDF")
	return /** @type {LocalizedString} */ ("Failed to export PDF")
});